// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { DATA_LAB_HELP } from '@aytm/app/stats/page/sidebar/components/lib/helps'

// components
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'

import DropTargetContainer from '@aytm/app/stats/page/sidebar/components/DropTargetContainer'

import CustomQuestionButton from '@aytm/app/stats/page/sidebar/components/CustomQuestionButton'
import PinnedCustomQuestion from '@aytm/app/stats/page/sidebar/components/PinnedCustomQuestion'

// styles
import style from '@aytm/app/stats/page/sidebar/data-lab/styles/DataLabPanel.module.scss'

const DataLabPanel = ({
  sidebar,
  root,
  data,
  features,
  buttons,
  questions,
  disabled,
  addCustomQuestion,
  addPinnedQuestion,
  removePinnedQuestion,
  onDNDStart,
  onDNDEnd
}) => {
  const acceptTypes = useMemo(
    () =>
      buttons.reduce((acc, cur) => {
        if (!features[cur.feature].disabled) acc.push(cur.adndType)
        return acc
      }, []),
    [buttons, features]
  )

  const typesTitles = useMemo(
    () =>
      buttons.reduce((acc, cur) => {
        if (!features[cur.feature].disabled) acc[cur.adndType] = cur.text
        return acc
      }, {}),
    [buttons, features]
  )

  return (
    <div className={style.component}>
      <div className={style['component-title']}>
        Data Lab
        <SidebarPopup id="datalab" root={root} help={DATA_LAB_HELP} width="300px" />
      </div>

      <DropTargetContainer
        root={sidebar}
        acceptTypes={acceptTypes}
        typesTitles={typesTitles}
        windowUID={data.windowUID}
        onDNDDrop={addPinnedQuestion}
      >
        {buttons.map(item =>
          features[item.feature].hidden ? null : (
            <CustomQuestionButton
              key={item.type}
              root={root}
              item={item}
              features={features}
              windowUID={data.windowUID}
              disabled={disabled}
              addCustomQuestion={addCustomQuestion}
              onDNDStart={onDNDStart}
              onDNDEnd={onDNDEnd}
            />
          )
        )}
        <div className={`${style.row} ${style.note} p-fluid`}>
          Click the button or drag it to the right to add your new chart exactly where you want it.
        </div>
        {0 < questions.length && !disabled ? (
          <>
            <div className={`${style.row} ${style['section-title']} p-fluid`}>Pinned questions</div>
            {questions.map(item => (
              <PinnedCustomQuestion
                key={`question-${item.index}`}
                item={item}
                features={features}
                disabled={disabled}
                addCustomQuestion={addCustomQuestion}
                removePinnedQuestion={removePinnedQuestion}
                onDNDStart={onDNDStart}
                onDNDEnd={onDNDEnd}
              />
            ))}
          </>
        ) : null}
      </DropTargetContainer>
    </div>
  )
}

DataLabPanel.propTypes = {
  sidebar: PropTypes.any,
  root: PropTypes.any,
  data: PropTypes.object,
  features: PropTypes.object,
  buttons: PropTypes.array,
  questions: PropTypes.array,
  disabled: PropTypes.bool,
  addCustomQuestion: PropTypes.func,
  addPinnedQuestion: PropTypes.func,
  removePinnedQuestion: PropTypes.func,
  onDNDStart: PropTypes.func,
  onDNDEnd: PropTypes.func
}

DataLabPanel.displayName = 'DataLabPanel'

export default DataLabPanel
